import { useEffect } from 'react'

const useForgotPasswordViewed = () => {
    useEffect(() => {
        dataLayer.push({
            event: 'forgot_password',
            step: 'form_view_forgot_password',
            _clear: true,
        })
    }, [])
}

export default useForgotPasswordViewed
